// Dependencies
import {
  TIPOS_ACT_COSTE_REQUEST,
  TIPOS_ACT_COSTE_OK,
  TIPOS_ACT_COSTE_ERROR,
} from "./types";
import { get } from "../../../../api/apiInstance";

const fetchTiposActCoste = () => async (dispatch) => {
  try {
    const response = await get("/tipos_act_coste");
    const data = response["data"];
    dispatch({
      type: TIPOS_ACT_COSTE_OK,
      payload: { data: data["data"], qty: data["rowsAffected"] },
    });
    return Promise.resolve();
  } catch (error) {
    dispatch({ type: TIPOS_ACT_COSTE_ERROR, payload: error });
    return Promise.reject(error);
  }
};

export const getTiposActCoste = () => (dispatch) => {
  dispatch({ type: TIPOS_ACT_COSTE_REQUEST });
  return dispatch(fetchTiposActCoste());
};
